import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TrialCourseDetail {
  id: string;
  teacher_code: string;
  name: string;
  nickname: string;
  student_name: string;
  student_nickname: string;
  class_date: string;
  class_type: string;
  location: string;
  grade: string;
  tier: string;
  cost: number;
  status: string;
  note: string;
  order_code: string | null;
  month: number;
  year: number;
}

export function useTeacherTrialDetails(
  teacherCode: string | null,
  startDate?: string,
  endDate?: string
) {
  return useQuery({
    queryKey: ["teacher-trial-details", teacherCode, startDate, endDate],
    queryFn: async () => {
      if (!teacherCode) return [];

      let query = supabase
        .from("v_trial_courses")
        .select("*")
        .eq("teacher_code", teacherCode)
        .order("class_date", { ascending: false });

      if (startDate) query = query.gte("class_date", startDate);
      if (endDate) query = query.lte("class_date", endDate);

      const { data, error } = await query;
      if (error) throw error;
      return data as TrialCourseDetail[];
    },
    enabled: !!teacherCode,
  });
}
